import React from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/AdminSendOTP.css"
// import {Link} from "react-router-dom";
import {useHistory} from 'react-router-dom'


function  AdminSendOTP() {
    const history = useHistory();
    const iniVal = {
        OTP: ''
    }

    const handleSendOTP =(values) => {
        // alert("ok")
        if(values.OTP === ''){
            alert('You need to Provide a OTP')
// 
        //     // alert('ok')
        //     // 
        }
        else{
            AuthService.checkOTP(values.OTP).then(res=>{
                if(res === 'OTP Verified'){
                    history.push('/new_pass')

                }
            })
        }
    }
    return (
        <div className="sendOTPMain">
            <div className="sendOTPContainer">
                <h4>Provide your OTP</h4>
                <Formik initialValues={iniVal} onSubmit={handleSendOTP}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="OTP" as={TextField}  label="OTP" variant="outlined" type="OTP" />
                                    {/* <Field name="cnEmail" as={TextField}  label="email" variant="outlined" type="email"/> */}
                                    <Button variant="contained" color="primary" type="submit">Submit</Button>
                                    {/* <Link className="link" to={"/send_OTP"}><Button variant="contained" color="primary">OTP</Button></Link> */}

                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default AdminSendOTP
